document.addEventListener("DOMContentLoaded", function (e) {
    const checkout = document.getElementById('checkout');
    if(checkout !== null) {
        checkout.addEventListener('click',(e) => {
            let singlePurchaseTotal = 0;
            let singlePurchaseProductName = [];
            fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                data['items'].forEach(e => {
                    if(single_purchase.indexOf(e.id.toString()) !== -1) {
                        singlePurchaseProductName.push(e.product_title);
                        singlePurchaseTotal++;
                    }
                });
                let isSubmit = true;
                if(singlePurchaseTotal > 0 && singlePurchaseTotal !== data['items'].length) isSubmit = false;
                if(isSubmit) {
                    const form_cart = document.getElementById('cart');
                    const hidden_checkout = form_cart.querySelector('#hidden_checkout');
                    const is_hidden_checkout = (hidden_checkout !== null) ? true : false;
                    if (!is_hidden_checkout) {
                        const cartSubmitInput = document.createElement('input');
                        cartSubmitInput.setAttribute('id', 'hidden_checkout');
                        cartSubmitInput.setAttribute('name', 'checkout');
                        cartSubmitInput.setAttribute('type', 'hidden');
                        document.querySelector('#cart').appendChild(cartSubmitInput);
                    }
                    form_cart.submit();
                } else {
                    alert('店舗受け取りのため物販商品と同時に購入することができません。');
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        });
    }
});